<template>
  <section>
    <LayoutAccount>
      <template #title>
        <template v-if="isPicaThirdLevelDomain">
          <div>{{ $t('pages.login.getPica_title') }}</div>
          <div style="color: #CECCE8; font-size: 16px;font-weight: 400;margin-top: 8px;">{{ $t('pages.login.getPica_subtitle') }}</div>
        </template>
        <template v-else>
        {{ $t('pages.login.headline_title_line1') }} {{ $t('pages.login.headline_title_line2') }}
        </template>
      </template>
      <template #subtitle>
        <template v-if="socialLoginOnTop">
          <SocialLogin :title="$t('forms.login_form.social_login_title_top')"/>
          {{ $t('forms.login_form.social_login_title_or') }}  <span class="text-lowercase">{{ $t('pages.login.headline_txt') }} <router-link :to="{ name: 'signup' }" exact
                                                                  class="text-primary">{{ $t('forms.login_form.create_account_btn') }}</router-link></span>
        </template>
        <template v-else>
          <span>{{ $t('pages.login.headline_txt') }} <router-link :to="{ name: 'signup' }" exact
                                                                  class="text-primary">{{ $t('forms.login_form.create_account_btn') }}</router-link></span>
        </template>
      </template>

      <template #mainContent>
        <LoginForm/>
      </template>
    </LayoutAccount>
    <template v-if="isPicaThirdLevelDomain">
      <B2BSection/>
    </template>
  </section>
</template>


<script>
import LayoutAccount from "@/components/LayoutAccount"
import LoginForm from '@/components/LoginForm'
import B2BSection from "@/components/B2BSection.vue";
import {mapGetters} from "vuex";
import SocialLogin from "@/components/SocialLogin.vue";

export default {
  components: {
    SocialLogin,
    B2BSection,
    LayoutAccount,
    LoginForm
  },
  computed: {
    ...mapGetters(['isPicaThirdLevelDomain', 'thirdLevelDomain']),
    socialLoginOnTop() {
      return ['photos'].includes(this.thirdLevelDomain)
    }
  },
}
</script>
